import React, { Component } from "react";

import { MdInfo } from "react-icons/md";
import COLORS from "scss/colors.module.scss";

export default class CustomPinnedRowEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  componentDidMount() {
    this.focus();
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  focus() {
    window.setTimeout(() => {
      document.addEventListener("mousedown", this.handleClickOutside);
    });
  }

  handleClickOutside(event) {
    if (
      this.wrapperRef &&
      !this.wrapperRef.contains(event.target) &&
      !this.state.editorModal
    ) {
      document.removeEventListener("mousedown", this.handleClickOutside);
      // this.props.api.clearRangeSelection();
      this.props.api.stopEditing(false);
      this.props.api.clearFocusedCell();
    }
  }

  getValue() {
    return this.state.value;
  }

  isPopup() {
    return true;
  }

  getListItem(icon, name, callback) {
    return (
      <div className="sheetOption" onClick={callback}>
        <div>{icon}</div>
        <div className="sheetOptionName">{name}</div>
      </div>
    );
  }

  render() {
    return (
      <div
        style={{ ...styles.menu, minWidth: Number(this.props.colDef.width) }}
        ref={this.setWrapperRef}
      >
        {this.getListItem(
          <MdInfo style={styles.icon} size={18} color={COLORS.PRIMARY_COLOR} />,
          "Sum",
          () => {
            this.props.context.selectAggregation(this.props.colDef.field, "Sum");
          }
        )}
        {this.getListItem(
          <MdInfo style={styles.icon} size={18} color={COLORS.PRIMARY_COLOR} />,
          "Average",
          () => {
            this.props.context.selectAggregation(this.props.colDef.field, "Avg");
          }
        )}
        {this.getListItem(
          <MdInfo style={styles.icon} size={18} color={COLORS.PRIMARY_COLOR} />,
          "Minimum",
          () => {
            this.props.context.selectAggregation(this.props.colDef.field, "Min");
          }
        )}
        {this.getListItem(
          <MdInfo style={styles.icon} size={18} color={COLORS.PRIMARY_COLOR} />,
          "Maximum",
          () => {
            this.props.context.selectAggregation(this.props.colDef.field, "Max");
          }
        )}
      </div>
    );
  }
}

const styles = {
  menu: {
    position: "absolute",
    top: 10,
    backgroundColor: "black",
  },
  icon: {
    marginTop: -5,
  },
};
